// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"721":"9bfce3fd","917":"be028901"}[chunkId] + ".chunk.js";
};